import { useEffect } from "react";

export function AnalyticsBridge() {
  useEffect(() => {
    const listener = (event) => {
      if (!window.abangColdConsent?.analytics) return;
      const payload = { ...event.detail, timestamp: new Date().toISOString() };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    };
    window.addEventListener("ac-analytics", listener);
    return () => window.removeEventListener("ac-analytics", listener);
  }, []);
  return null;
}
